/* SHOEKIDS UNIVERSE — theme.js (no dependencies) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const routes = (window.shoekids && window.shoekids.routes) || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root_url: '/' };
  const useDrawer = !window.shoekids || window.shoekids.cartType !== 'page';

  /* ---------- Announcement rotator ---------- */
  $$('[data-announcement]').forEach((track) => {
    const items = $$('.announcement__item', track);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      if (track.classList.contains('announcement__track--split') && window.innerWidth >= 1200) return;
      const cur = items[i];
      i = (i + 1) % items.length;
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      setTimeout(() => cur.classList.remove('is-leaving'), 500);
      items[i].classList.add('is-active');
    }, 3800);
  });

  /* ---------- Header hide on scroll down ---------- */
  const header = $('.header-wrapper');
  if (header) {
    let last = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-hidden', y > last && y > 240 && !document.body.classList.contains('is-locked'));
      last = y;
    }, { passive: true });
  }

  /* ---------- Drawers ---------- */
  const overlay = $('[data-overlay]');
  const lock = (on) => document.body.classList.toggle('is-locked', on);
  const openDrawer = (el) => { if (!el) return; el.classList.add('is-open'); overlay && overlay.classList.add('is-open'); lock(true); const f = el.querySelector('button, a'); f && f.focus({ preventScroll: true }); };
  const closeAll = () => { $$('.cart-drawer.is-open, .menu-drawer.is-open').forEach((d) => d.classList.remove('is-open')); overlay && overlay.classList.remove('is-open'); lock(false); };

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-open-menu], [data-open-cart], [data-close-drawer]');
    if (!t) return;
    if (t.hasAttribute('data-close-drawer')) { e.preventDefault(); closeAll(); return; }
    if (t.hasAttribute('data-open-menu')) { e.preventDefault(); openDrawer($('.menu-drawer')); return; }
    if (t.hasAttribute('data-open-cart') && useDrawer && $('.cart-drawer')) { e.preventDefault(); openDrawer($('.cart-drawer')); }
  });
  overlay && overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------- Cart (AJAX) ---------- */
  const refreshCart = async (open = true) => {
    try {
      const res = await fetch(`${routes.root_url.replace(/\/$/, '')}/?sections=cart-drawer`);
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.querySelector('.cart-drawer');
      const current = $('.cart-drawer');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        const count = fresh.getAttribute('data-count');
        $$('[data-cart-count]').forEach((c) => { c.textContent = count === '0' ? '' : count; c.setAttribute('data-count', count); });
      }
      if (open) openDrawer($('.cart-drawer'));
    } catch (err) { window.location.href = routes.cart_url; }
  };

  const addToCart = async (formData, button) => {
    if (!useDrawer) return false;
    button && button.classList.add('is-loading');
    try {
      const res = await fetch(`${routes.cart_add_url}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
      const json = await res.json();
      if (json.status) { alert(json.description || json.message); return true; }
      if (button) { button.classList.add('is-added'); setTimeout(() => button.classList.remove('is-added'), 1600); }
      await refreshCart(true);
    } catch (err) { return false; } finally { button && button.classList.remove('is-loading'); }
    return true;
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !useDrawer) return;
    e.preventDefault();
    const ok = await addToCart(new FormData(form), form.querySelector('[type="submit"]'));
    if (!ok) form.submit();
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const fd = new FormData();
    fd.append('id', btn.dataset.quickAdd);
    fd.append('quantity', 1);
    const ok = await addToCart(fd, btn);
    if (!ok) window.location.href = btn.dataset.url || routes.cart_url;
  });

  const changeLine = async (line, quantity) => {
    const drawer = $('.cart-drawer');
    drawer && drawer.setAttribute('aria-busy', 'true');
    await fetch(`${routes.cart_change_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
    if ($('[data-cart-page]')) { window.location.reload(); return; }
    await refreshCart(false);
    drawer && drawer.removeAttribute('aria-busy');
  };

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const wrap = b.closest('.qty');
    const input = wrap.querySelector('input');
    const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qtyStep, 10));
    input.value = next;
    if (wrap.hasAttribute('data-line')) changeLine(parseInt(wrap.dataset.line, 10), next);
  });
  document.addEventListener('click', (e) => {
    const r = e.target.closest('[data-remove-line]');
    if (!r) return;
    e.preventDefault();
    changeLine(parseInt(r.dataset.removeLine, 10), 0);
  });

  /* ---------- Product: variants ---------- */
  $$('[data-product-form]').forEach((root) => {
    const json = root.querySelector('[data-variants]');
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = root.querySelector('input[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const btns = $$('[data-atc]');
    const update = () => {
      const chosen = $$('fieldset.option', root).map((fs) => (fs.querySelector('input:checked') || {}).value);
      const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      if (!v) { btns.forEach((b) => { b.disabled = true; b.querySelector('span').textContent = 'unavailable'; }); return; }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html;
      btns.forEach((b) => { b.disabled = !v.available; b.querySelector('span').textContent = v.available ? 'add to cart' : 'sold out'; });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    };
    root.addEventListener('change', (e) => { if (e.target.closest('fieldset.option')) update(); });
  });

  /* Sticky add-to-cart on mobile */
  const mainAtc = $('[data-main-atc]');
  const sticky = $('.sticky-atc');
  if (mainAtc && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(mainAtc);
    sticky.querySelector('button').addEventListener('click', () => mainAtc.click());
  }

  /* Product gallery dots (mobile) */
  $$('[data-gallery]').forEach((g) => {
    const dots = $$('span', g.nextElementSibling || document.createElement('div'));
    if (!dots.length) return;
    g.addEventListener('scroll', () => {
      const i = Math.round(g.scrollLeft / (g.firstElementChild.offsetWidth + 10));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    }, { passive: true });
  });

  /* ---------- Horizontal gallery buttons ---------- */
  $$('[data-scroller]').forEach((wrap) => {
    const track = wrap.querySelector('.gallery');
    $$('[data-dir]', wrap).forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: parseInt(b.dataset.dir, 10) * track.clientWidth * 0.7, behavior: 'smooth' })));
  });

  /* ---------- Collection sort ---------- */
  $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    window.location.href = url.toString();
  }));

  /* ---------- Newsletter: friendly success ---------- */
  if (window.location.search.includes('customer_posted=true')) {
    $$('[data-newsletter-success]').forEach((el) => { el.hidden = false; });
  }

  /* ---------- Reveal on scroll ---------- */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach((el) => io.observe(el));
  } else reveals.forEach((el) => el.classList.add('is-in'));
})();
